var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8864_52824)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 12.8008,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1 13.5078C28.0421 13.5078 21.5094 20.0407 21.5094 28.099C21.5094 36.1572 28.0421 42.6901 36.1 42.6901C44.158 42.6901 50.6906 36.1572 50.6906 28.099C50.6906 20.0407 44.158 13.5078 36.1 13.5078ZM34.0102 35.4369C27.8589 31.3248 20.9838 23.7395 26.3623 18.3608C31.7407 12.9822 40.4593 12.9822 45.8378 18.3608C50.2074 22.7306 50.7078 29.1662 48.2951 34.5037C46.8787 37.6367 40.3334 39.6636 34.0102 35.4369Z",
    fill: "#FBC44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0457 31.0042V23.7632H31.8764V31.0042H30.0457ZM27.3406 28.299V26.4684H34.5815V28.299H27.3406ZM40.3604 32.7428C39.5967 32.7428 38.9166 32.6115 38.32 32.349C37.7268 32.0831 37.2581 31.7184 36.9138 31.2547C36.5729 30.7877 36.3973 30.249 36.3871 29.6388H38.6166C38.6302 29.8945 38.7138 30.1195 38.8672 30.3138C39.024 30.5047 39.232 30.653 39.491 30.7587C39.7501 30.8644 40.0416 30.9172 40.3655 30.9172C40.703 30.9172 41.0013 30.8576 41.2604 30.7382C41.5195 30.6189 41.7223 30.4536 41.8689 30.2422C42.0155 30.0309 42.0888 29.7871 42.0888 29.511C42.0888 29.2314 42.0104 28.9843 41.8535 28.7695C41.7001 28.5513 41.4785 28.3809 41.1888 28.2581C40.9024 28.1354 40.5615 28.074 40.166 28.074H39.1893V26.4479H40.166C40.5001 26.4479 40.795 26.3899 41.0507 26.274C41.3098 26.1581 41.5109 25.9979 41.6541 25.7934C41.7973 25.5854 41.8689 25.3434 41.8689 25.0672C41.8689 24.8047 41.8058 24.5746 41.6797 24.3769C41.557 24.1757 41.3831 24.0189 41.1581 23.9064C40.9365 23.7939 40.6774 23.7377 40.3808 23.7377C40.0808 23.7377 39.8064 23.7922 39.5575 23.9013C39.3087 24.007 39.1092 24.1587 38.9592 24.3564C38.8092 24.5542 38.7291 24.786 38.7189 25.0519H36.5967C36.607 24.4485 36.7791 23.9167 37.1132 23.4564C37.4473 22.9962 37.8973 22.6365 38.4632 22.3774C39.0325 22.1149 39.6751 21.9837 40.391 21.9837C41.1138 21.9837 41.7462 22.1149 42.2882 22.3774C42.8302 22.6399 43.2513 22.9945 43.5513 23.4411C43.8547 23.8843 44.0047 24.382 44.0013 24.9343C44.0047 25.5206 43.8223 26.0098 43.4541 26.4019C43.0893 26.7939 42.6138 27.0428 42.0274 27.1485V27.2303C42.7979 27.3292 43.3842 27.5968 43.7865 28.0331C44.1922 28.4661 44.3933 29.0081 44.3899 29.6593C44.3933 30.2559 44.2212 30.786 43.8734 31.2496C43.5291 31.7132 43.0535 32.078 42.4467 32.3439C41.8399 32.6098 41.1445 32.7428 40.3604 32.7428Z",
    fill: "#DD9700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8864_52824",
    x: 0.800049,
    y: 0.800781,
    width: 70.4,
    height: 70.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.768627 0 0 0 0 0.301961 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8864_52824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8864_52824",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints3);
export default __webpack_public_path__ + "static/media/Points_3.4c8007f29855aff1e0c370362d364ebf.svg";
export { ForwardRef as ReactComponent };